import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWallet = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16 16",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0)",
		children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M14.5,12.3v1c0,1.1-0.9,2-2,2h-10c-1.1,0-2-0.9-2-2v-7c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v1 "
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M12.5,4.3l-1.6-3.1c-0.2-0.4-0.6-0.6-1-0.6c-0.1,0-0.3,0-0.4,0.1L2.5,4.3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M14.5,12.3c0.6,0,1-0.4,1-1v-3c0-0.6-0.4-1-1-1H12c-1.4,0-2.5,1.1-2.5,2.5 c0,1.4,1.1,2.5,2.5,2.5H14.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "M12,10.1c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				d: "M12,10.1c0.1,0,0.2-0.1,0.2-0.2S12.1,9.6,12,9.6"
			})
		] })
	})
});
export { SvgIconWallet as ReactComponent };
